import { useCallback } from 'react';
import { useAuthStore } from '@stores/authStore';
import { useVoiceAgentStore } from '@stores/voiceAgentStore';
import { useIdleLogout } from '@hooks/useIdleLogout';

/**
 * Signs out a tenant or platform user after 30 minutes without input. Paused
 * during a live call, when an agent may go a long time without touching the
 * keyboard. Rendered once at the app root.
 */
export function IdleLogout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logout = useAuthStore((s) => s.logout);
  const onCall = useVoiceAgentStore((s) => !!s.activeCall);

  const onIdle = useCallback(async () => {
    const isPlatformUser = !!useAuthStore.getState().user?.isPlatformUser;
    await logout();
    // A full document load, like MainLayout's sign-out, so no in-memory
    // store keeps this session's data.
    window.location.assign(isPlatformUser ? '/platform-admin' : '/login?reason=idle_timeout');
  }, [logout]);

  useIdleLogout({ enabled: isAuthenticated, paused: onCall, onIdle });
  return null;
}
